import { z } from 'zod';
export const PageSchema = z.object({
    limit: z.number().multipleOf(1).nonnegative(),
    offset: z.number().multipleOf(1).nonnegative(),
    total: z.number().multipleOf(1).nonnegative(),
});
export function createPaginatedListResponseSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        page: PageSchema,
    });
}
//# sourceMappingURL=PaginatedListResponse.js.map